// extracted by mini-css-extract-plugin
module.exports = {"newsList":"styles-module--newsList--T-Qfv"};